<div class="layout-ParentDiv innerDiv">
	<div class="layout-dashboard" [ngClass]="hide ? 'responsiveHide-column' : 'responsiveShow-column'">
		<div class="mainDivHeader">
			<div class="leftdiv">
				<h4>User Wallet Report <span class="badge">{{totalRecords }}</span></h4>
			</div>
			<div class="rightDiv">
				<button class="exportBTn" (click)="exportExcel()"> <span><img src="../../../assets/images/backend-image/header/exportIcon.svg"
							alt=""></span>
					Export</button>
			</div>
		</div>
		<div class="mainDivBody">
			<div class="date-filterDiv">
				<ul class="filtersList">
					<li>
						<p-dropdown inputId="searchfield" [options]="searchBy" [(ngModel)]="searchby" optionLabel="label"></p-dropdown>
					</li>
					<li>
						<p-calendar appendTo="body" monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
							[(ngModel)]="startDate" class="p-calendar w-100" inputId="calendar" dateFormat="dd/mm/yy"
							placeholder="From: dd / mm / yy" [showIcon]="true"></p-calendar>
					</li>
					<li>
						<p-calendar appendTo="body" monthNavigator="true" yearNavigator="true" yearRange="2022:2050"
							[(ngModel)]="endDate" class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy"
							placeholder="To: dd / mm / yy" [showIcon]="true"></p-calendar>
					</li>
					<li>
						<button (click)="loadWallet($event)" class="searchFilterBtn">
							<img src="../../../assets/images/backend-image/common-images/search.svg" alt="">
						</button>
					</li>
					<li>
						<button (click)="clear()" class="clearFilterBtn">
							<img src="../../../assets/images/backend-image/common-images/delete.svg" alt="">
							<span>Clear All</span>
						</button>

					</li>
				</ul>

			</div>
			<div class="maintableDiv">
				<div class="tableParanet">
					<p-table class=" expandable" #dt [value]="walletlist" [paginator]="true" [rows]="10" [lazy]="true"
						[scrollable]="true" scrollHeight="auto" scrollDirection="both" (onLazyLoad)="loadWallet($event)"
						[totalRecords]="totalRecords" [loading]="loading" [rowsPerPageOptions]="paginationOption"
						styleClass="p-datatable-gridlines p-datatable-striped">
						<ng-template pTemplate="header" let-columns>
							<tr>
								<th pfrozencolumn="" class="titleTD" style="left: 0px;" pSortableColumn="addTotal">
									<div class="p-d-flex p-jc-between p-ai-center">
										Add Total
										<p-sortIcon field="addTotal"></p-sortIcon>
									</div>
								</th>
								<th pfrozencolumn="" class="titleTD" style="left: 0px;" pSortableColumn="subtractTotal">
									<div class="p-d-flex p-jc-between p-ai-center">
										Subtract Total
										<p-sortIcon field="subtractTotal"></p-sortIcon>
									</div>
								</th>
								<th pfrozencolumn="" pSortableColumn="userId" style="left: 0px;" class="titleTD">
									<div class="p-d-flex p-jc-between p-ai-center">
										User Id
										<p-sortIcon field="userId"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="total" class="titleTD">
									<div class="p-d-flex p-jc-between p-ai-center">
										Total
										<p-sortIcon field="total"></p-sortIcon>
									</div>
								</th>
								<th pSortableColumn="mobileNumber" class="titleTD">
									<div class="p-d-flex p-jc-between p-ai-center">
										Mobile Number
										<p-sortIcon field="mobileNumber"></p-sortIcon>
									</div>
								</th>
								<th class="updatedTD" pSortableColumn="emailId">
									<div class="p-d-flex p-jc-between p-ai-center">
										Email Id
										<p-sortIcon field="emailId"></p-sortIcon>
									</div>
								</th>

								<th pSortableColumn="firstName" class="titleTD">
									<div class="p-d-flex p-jc-between p-ai-center">
										First Name
										<p-sortIcon field="firstName"></p-sortIcon>
									</div>
								</th>
                                <th pSortableColumn="lastName" class="titleTD">
									<div class="p-d-flex p-jc-between p-ai-center">
										Last Name
										<p-sortIcon field="lastName"></p-sortIcon>
									</div>
								</th>
							</tr>
							<tr>
								<th [ngSwitch]="name" pfrozencolumn="" class="titleTD" style="left: 0px;">
                                    <input pInputText type="number"
										(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'addTotal', 'contains')"
										style="width: 90px;"
										[value]="dt.filters['addTotal'] ? dt.filters['addTotal'].value : ''" />
								</th>

								<th [ngSwitch]="coins" pfrozencolumn="" class="titleTD" style="left: 0px;">
                                    <input pInputText type="number"
										(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'subtractTotal', 'contains')"
										style="width: 90px;"
										[value]="dt.filters['subtractTotal'] ? dt.filters['subtractTotal'].value : ''" />
								</th>

								<th [ngSwitch]="status" class="titleTD" style="left: 0px;">
                                    <input pInputText type="text"
										(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'userId', 'contains')"
										style="width: 90px;"
										[value]="dt.filters['userId'] ? dt.filters['userId'].value : ''" />
								</th>

								<th [ngSwitch]="updated_at" class="titleTD">
                                    <input pInputText type="number"
										(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'total', 'contains')"
										style="width: 90px;"
										[value]="dt.filters['total'] ? dt.filters['total'].value : ''" />
								</th>
								<th [ngSwitch]="created_at" class="titleTD">
									<input pInputText type="text"
										(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'mobileNumber', 'contains')"
										style="width: 90px;"
										[value]="dt.filters['mobileNumber'] ? dt.filters['mobileNumber'].value : ''" />
								</th>
								<th [ngSwitch]="emailId" class="titleTD">
									<input pInputText type="text"
										(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'emailId', 'contains')"
										style="width: 90px;"
										[value]="dt.filters['emailId'] ? dt.filters['emailId'].value : ''" />
								</th>

								<th [ngSwitch]="firstName" class="titleTD">
									<input pInputText type="text"
										(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'firstName', 'contains')"
										style="width: 90px;"
										[value]="dt.filters['firstName'] ? dt.filters['firstName'].value : ''" />
								</th>

                                <th [ngSwitch]="lastName" class="titleTD">
									<input pInputText type="text"
										(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'lastName', 'contains')"
										style="width: 90px;"
										[value]="dt.filters['lastName'] ? dt.filters['lastName'].value : ''" />
								</th>
							</tr>
						</ng-template>
						<ng-template pTemplate="body" let-userwallet>
							<tr class="p-selectable-row">
								<td pfrozencolumn="" class="titleTD" style="left: 0px; z-index: 1001; display: flex;">
									{{userwallet?.addTotal}}
								</td>
								<td pfrozencolumn="" class="titleTD" style="left: 0px; z-index: 1001; display: flex;">
									{{userwallet?.subtractTotal}}
								</td>
								<td class="titleTD"  style="left: 0px; z-index: 1001; display: flex;">
                                    {{userwallet?.userId}}
								</td>

								<td class="col-150 titleTD">
									{{userwallet?.total}}
								</td>
								<td class="col-200 titleTD">
									{{userwallet?.mobileNumber}}
								</td>
								<td class="col-200 titleTD">
									{{userwallet?.emailId}}
								</td>

								<td class="col-200 titleTD">
									{{userwallet?.firstName}}
								</td>

                                <td class="col-200 titleTD">
									{{userwallet?.lastName}}
								</td>
							</tr>
						</ng-template>
						<ng-template pTemplate="emptymessage">
							<tr>
								<td colspan="7">User Wallet not found.</td>
							</tr>
						</ng-template>
					</p-table>
				</div>
			</div>
		</div>
	</div>
</div>